import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { configurationRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {configurationRoutes.map((prop, key) => {
      if (prop.layout === 'configuration') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/configuration" to="/configuration/details" />
  </Switch>
);

const Configuration = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Configuration;
